var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('static-string',[_vm._v("\n    Characters entered: \n  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.charCount)+" / "+_vm._s(_vm.maxChars)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }